"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserTimesheetsController = function () {
  function UserTimesheetsController(JobsService, NotificationService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserTimesheetsController);
    this.JobsService = JobsService;
    this.NotificationService = NotificationService;
    this.$scope = $scope;
    this._searchTimer = null;
    this.searchJobId = '';
    this._deletedJobIds = new _set2.default(); // track locally deleted job IDs
  }

  (0, _createClass3.default)(UserTimesheetsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this._dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);

      this._dataSource.bind("requestStart", function () {
        // Use Kendo's native progress over the whole component so it always shows
        kendo.ui.progress($("#timesheets-grid"), true);
      });

      this._dataSource.bind("requestEnd", function () {
        kendo.ui.progress($("#timesheets-grid"), false);
      });

      this._dataSource.bind("error", function () {
        kendo.ui.progress($("#timesheets-grid"), false);
      });

      // After every read from the API, strip out any locally-deleted jobs
      this._dataSource.bind('change', function () {
        _this._removeDeletedFromDataSource();
      });

      var ctr = this;
      this.confirmDeleteDialogOptions = {
        title: 'Confirm Remove',
        visible: false,
        closable: true,
        modal: true,
        buttonLayout: 'normal',
        messages: { close: '' },
        actions: [{ text: 'No' }, {
          text: 'Yes',
          primary: true,
          action: function action() {
            return ctr._doDelete();
          }
        }]
      };

      this.gridOptions = {
        dataSource: this._dataSource,
        sortable: true,
        pageable: true,
        resizable: true,
        noRecords: {
          template: 'No Completed One-off Jobs found.'
        },
        columns: [{ field: 'id', title: 'Job ID', width: '100px', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' }, { field: 'paymentType', title: 'Payment Type', width: '130px', filterable: false, template: '#= (data.paymentType == 1 || data.PaymentType == 1) ? "Fixed Payment" : (data.paymentType == 2 || data.PaymentType == 2) ? "Hourly Payment" : (data.paymentType || data.PaymentType || "") #' }, { field: 'jobDate', title: 'Job Date', width: '120px', filterable: false, template: "#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), 'dd/MM/yyyy') : \"\" #" }, { field: 'price', title: 'Price ($)', width: '100px', filterable: false, template: '#= data.price || data.Price || 0 #' }, { field: 'jobStatus', title: 'Job Status', width: '120px', filterable: false, template: 'Completed' }, {
          command: [{
            text: 'Remove Timesheet',
            className: 'k-grid-deleteTimesheet',
            click: this.deleteTimesheet.bind(this)
          }],
          title: 'Actions',
          width: '160px'
        }]
      };
    }
  }, {
    key: "onSearchInput",
    value: function onSearchInput() {
      var _this2 = this;

      // Show loader as soon as user types
      this.isSearching = true;

      // Clear any existing timer on every keystroke
      if (this._searchTimer) {
        clearTimeout(this._searchTimer);
      }

      // Start a new 2-second debounce timer
      this._searchTimer = setTimeout(function () {
        // Input type="number" gives a Number, so cast to String before .trim()
        var term = String(_this2.searchJobId || '').trim();

        if (term === '') {
          // No search term — clear filter, show all records
          _this2._dataSource.filter([]);
        } else {
          var parsedTerm = parseInt(term, 10) || 0;
          // Filter where any id variant matches the typed job ID
          _this2._dataSource.filter({
            logic: "or",
            filters: [{ field: 'id', operator: 'eq', value: parsedTerm }, { field: 'jobId', operator: 'eq', value: parsedTerm }, { field: 'JobId', operator: 'eq', value: parsedTerm }, { field: 'Id', operator: 'eq', value: parsedTerm }]
          });
        }

        _this2._searchTimer = null;
        _this2.isSearching = false;
        _this2.$scope.$applyAsync();
      }, 2000);
    }
  }, {
    key: "_removeDeletedFromDataSource",
    value: function _removeDeletedFromDataSource() {
      var _this3 = this;

      if (this._deletedJobIds.size === 0) return;
      var ds = this._dataSource;
      var toRemove = ds.data().filter(function (item) {
        var id = item.id || item.jobId || item.JobId || item.Id;
        return _this3._deletedJobIds.has(id);
      });
      toRemove.forEach(function (item) {
        return ds.remove(item);
      });
    }
  }, {
    key: "deleteTimesheet",
    value: function deleteTimesheet(e) {
      e.preventDefault();
      var grid = $(e.target).closest("[data-role=grid]").data("kendoGrid");
      var dataItem = grid.dataItem($(e.target).closest("tr"));
      this._pendingDeleteJobId = dataItem.id || dataItem.jobId || dataItem.JobId || dataItem.Id;
      this.confirmDeleteDialog.open();
    }
  }, {
    key: "_doDelete",
    value: function _doDelete() {
      var _this4 = this;

      if (!this._pendingDeleteJobId) return;

      // Show loader over the component while the delete API is running
      this.isDeleting = true;
      this.$scope.$applyAsync();

      this.JobsService.deleteTimesheet(this._pendingDeleteJobId, function () {
        _this4.isDeleting = false;
        _this4.$scope.$applyAsync();
        _this4.NotificationService.success("Timesheet is removed");

        // Add to local blacklist so this job never shows again even after search
        _this4._deletedJobIds.add(_this4._pendingDeleteJobId);

        var grid = $("#timesheets-grid").data("kendoGrid");
        if (grid) {
          // Immediately remove from in-memory data so it disappears instantly
          var dataItem = grid.dataSource.get(_this4._pendingDeleteJobId);
          if (dataItem) {
            grid.dataSource.remove(dataItem);
          } else {
            _this4._removeDeletedFromDataSource();
          }
        }
        _this4._pendingDeleteJobId = null;
      }, function (error) {
        _this4.isDeleting = false;
        _this4.$scope.$applyAsync();
        _this4.NotificationService.error("Failed to remove timesheet: " + (error && error.data || "Unknown error"));
        _this4._pendingDeleteJobId = null;
      });
    }
  }]);
  return UserTimesheetsController;
}();

exports.default = UserTimesheetsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-timesheets/user-timesheets.controller.js
 **/